var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "item-list" },
    [
      _c(
        "div",
        { staticClass: "item-list-header header" },
        [
          _vm._t("back-button"),
          _vm._v(" "),
          _c("h1", { staticClass: "item-list-title header-title" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t(_vm.title.charAt(0).toUpperCase() + _vm.title.slice(1))
                ) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "item-list-toolbar header-toolbar btn-toolbar" },
            [_vm._t("add-button")],
            2
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-toolbar item-list-actions" },
        [
          _vm.selector &&
          (_vm.$can("update " + _vm.table) || _vm.$can("delete " + _vm.table))
            ? _c("item-list-selector", {
                staticClass: "me-2",
                attrs: {
                  "filtered-models": _vm.filteredItems,
                  "all-checked": _vm.allChecked,
                  loading: _vm.loading,
                  publishable: _vm.publishable,
                },
                on: {
                  "check-all": _vm.checkAll,
                  "check-none": _vm.checkNone,
                  "check-published": _vm.checkPublished,
                  "check-unpublished": _vm.checkUnpublished,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.actions &&
          (_vm.$can("update " + _vm.table) || _vm.$can("delete " + _vm.table))
            ? _c("item-list-actions", {
                staticClass: "me-2",
                attrs: {
                  "number-of-checked-models": _vm.numberOfCheckedItems,
                  loading: _vm.loading,
                  publishable: _vm.publishable,
                  table: _vm.table,
                },
                on: {
                  destroy: _vm.destroy,
                  publish: _vm.publish,
                  unpublish: _vm.unpublish,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pagination &&
          this.data.total > 10 &&
          _vm.$can("read " + _vm.table)
            ? _c("item-list-per-page", {
                staticClass: "me-2",
                attrs: {
                  loading: _vm.loading,
                  "per-page": parseInt(_vm.data.per_page),
                },
                on: { "change-per-page": _vm.changeNumberOfItemsPerPage },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._t("buttons"),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-items-center ms-2" }, [
            _vm.loading
              ? _c(
                  "div",
                  {
                    staticClass:
                      "spinner-border spinner-border-sm text-secondary",
                    attrs: { role: "status" },
                  },
                  [
                    _c("span", { staticClass: "visually-hidden" }, [
                      _vm._v(_vm._s(_vm.$t("Loading…"))),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          !_vm.loading
            ? _c("small", { staticClass: "text-muted align-self-center" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$tc("# " + _vm.title, _vm.data.total, {
                        count: _vm.data.total,
                      })
                    ) +
                    "\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex ms-auto" }, [
            _vm.searchable.length > 0
              ? _c("div", { staticClass: "filters form-inline" }, [
                  _c(
                    "div",
                    { staticClass: "input-group input-group-sm mb-0" },
                    [
                      _c("div", { staticClass: "input-group-text" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 1792 1792",
                              fill: "currentColor",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M1216 832q0-185-131.5-316.5t-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5 316.5-131.5 131.5-316.5zm512 832q0 52-38 90t-90 38q-54 0-90-38l-343-342q-179 124-399 124-143 0-273.5-55.5t-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5 273.5 55.5 225 150 150 225 55.5 273.5q0 220-124 399l343 343q37 37 37 90z",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchString,
                            expression: "searchString",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "search" },
                        domProps: { value: _vm.searchString },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.searchString = $event.target.value
                            },
                            _vm.onSearchStringChanged,
                          ],
                        },
                      }),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.multilingual && _vm.locales.length > 1
              ? _c("div", { staticClass: "btn-group btn-group-sm ms-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-light dropdown-toggle",
                      attrs: {
                        type: "button",
                        id: "dropdownLangSwitcher",
                        "data-bs-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false",
                      },
                    },
                    [
                      _c("span", { attrs: { id: "active-locale" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.locales.find(function (item) {
                              return item.short === _vm.currentLocale
                            }).long
                          )
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu dropdown-menu-right",
                      attrs: { "aria-labelledby": "dropdownLangSwitcher" },
                    },
                    _vm._l(_vm.locales, function (locale) {
                      return _c(
                        "button",
                        {
                          staticClass: "dropdown-item",
                          class: { active: locale === _vm.currentLocale },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.switchLocale(locale.short)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(locale.long) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.exportable
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-sm btn-light ms-2",
                    attrs: { href: this.exportUrl },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "bi bi-table",
                        attrs: {
                          width: "1em",
                          height: "1em",
                          viewBox: "0 0 16 16",
                          fill: "currentColor",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            d: "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 2h-4v3h4V4zm0 4h-4v3h4V8zm0 4h-4v3h3a1 1 0 0 0 1-1v-2zm-5 3v-3H6v3h4zm-5 0v-3H1v2a1 1 0 0 0 1 1h3zm-4-4h4V8H1v3zm0-4h4V4H1v3zm5-3v3h4V4H6zm4 4H6v3h4V8z",
                          },
                        }),
                      ]
                    ),
                    _vm._v("\n                Export\n            "),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _vm.filteredItems.length
        ? _c("div", { staticClass: "table-responsive" }, [
            _c("table", { staticClass: "table item-list-table" }, [
              _c("thead", [
                _c(
                  "tr",
                  [_vm._t("columns", null, { sortArray: _vm.sortArray })],
                  2
                ),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.filteredItems, function (model) {
                  return _c(
                    "tr",
                    [
                      _vm._t("table-row", null, {
                        model: model,
                        checkedModels: _vm.checkedItems,
                        loading: _vm.loading,
                      }),
                    ],
                    2
                  )
                }),
                0
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.pagination
        ? _c("item-list-pagination", {
            attrs: { data: _vm.data },
            on: { "pagination-change-page": _vm.changePage },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }